import '@babel/polyfill/dist/polyfill.min'
import 'intersection-observer'
import { detect } from 'detect-browser'
import MobileDetect from 'mobile-detect/mobile-detect.min'
import 'url-search-params-polyfill'
import EventEmitter from 'eventemitter3'
import SwipeListener from 'swipe-listener/dist/swipe-listener.min'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import Swiper from 'swiper/js/swiper.min.js'

window.EventEmitter = EventEmitter
window.detect = detect
window.MobileDetect = MobileDetect
window.SwipeListener = SwipeListener
window.WebFont = require('webfontloader')
window.disableBodyScroll = disableBodyScroll
window.enableBodyScroll = enableBodyScroll
window.clearAllBodyScrollLocks = clearAllBodyScrollLocks
window.Swiper = Swiper

//PIXI
import 'vendors/pixi.js/pixi.min'

//GSAP
import 'vendors/gsap/TweenMax.min'
import 'vendors/gsap/plugins/SplitText.min'
import 'vendors/gsap/plugins/PixiPlugin.min'

//SCROLLMAGIC
import 'vendors/scrollmagic/ScrollMagic.min'
import 'vendors/scrollmagic/plugins/animation.gsap.min'
//import 'vendors/scrollmagic/plugins/debug.addIndicators.min'

const tag = document.createElement('script')
tag.src = "https://www.youtube.com/iframe_api"
const firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

window.youtubeAPI = false
window.onYouTubeIframeAPIReady = () => window.youtubeAPI = true